import React from 'react';

import { ProdStackManagerIntl } from 'types/i18n';
import { TextComponent } from 'design/text/textComponents';
import { LinkControlComponent } from 'design/linkControl';
import { NON_BREAKING_SPACE, SUPPORT_MAIL } from 'utils/constants';
import { ParagraphComponent } from 'design/paragraph';
import { normalizeProfileLike } from 'utils/profileLikeUtils';

export const prodStackManagerIntl: ProdStackManagerIntl = {
  emailConfirm: {
    titleText: 'Создание аккаунта',
    detailsText(email) {
      return (
        <TextComponent>
          <ParagraphComponent>
            Бесплатная лицензия на 365 дней для вас и 4 подчиненных.
          </ParagraphComponent>
          <ParagraphComponent>
            Пожалуйста, подтвердите указанный ранее email адрес:
          </ParagraphComponent>
          <ParagraphComponent>
            <TextComponent weight="bold">{email}</TextComponent>
          </ParagraphComponent>
        </TextComponent>
      );
    },
    primaryActionText: 'Подтвердить',
    secondaryActionText: 'Изменить',
  },
  phoneConfirm: {
    titleText: 'Создание аккаунта',
    phoneInputLabelText: 'Ваш телефон',
    phoneInvalidText: 'Неверный формат номера',
    sendCodeActionText: 'Продолжить',
    codeLabel: 'Введите код, который вы получили на телефон',
    codeInvalidLabel: 'Некорректный код, попробуйте еще раз:',
    sendCodeFallbackText: 'Не удалось отправить код. Попробуйте позже',
    changePhoneActionText: 'изменить',
    phoneCountrySearchPlaceholder: 'Поиск страны',
    phoneCountryNotFound: 'Страна не найдена',
  },
  promocodeForm: {
    titleText: 'Создание аккаунта',
    promocodeInputLabelText: 'Укажите ваш персональный код:',
    promocodeInputFallbackLabelText: 'Некорректный код, попробуйте еще раз:',
    hintText() {
      return (
        <TextComponent>
          Или напишите нам, чтобы получить код:{' '}
          <LinkControlComponent to={`mailto:${SUPPORT_MAIL}`}>
            <TextComponent color="accent" animatedColor>
              {SUPPORT_MAIL}
            </TextComponent>
          </LinkControlComponent>
        </TextComponent>
      );
    },
  },
  clientInfoForm: {
    titleText: 'Ваши данные',
    firstNameInputLabelText: 'Имя',
    middleNameInputLabelText: 'Отчество',
    lastNameInputLabelText: 'Фамилия',
    phoneInputLabelText: 'Ваш телефон',
    positionInputLabelText: 'Ваша должность (сокращенно)',
    positionMaxLengthHintText: 'Не более 15 символов',
    partnerCodeLabel: `Введите код партнера, который вас пригласил (если${NON_BREAKING_SPACE}есть):`,
    partnerFoundByCodeText(profile) {
      const name = normalizeProfileLike(profile).toShortestName();

      return `Ваш партнер: ${name}`;
    },
    nameInputLabelText: 'Название организации',
    locationInputLabelText: 'Страна регистрации',
    staffCountInputLabelText: 'Количество сотрудников',
    actionText: 'Продолжить',
    staffCountText(orgStaffCount) {
      switch (orgStaffCount) {
        case 'large':
          return 'более 500';
        case 'medium':
          return 'до 500';
        case 'small':
          return 'до 100';
        default:
          return '';
      }
    },
    partnerNotFoundByCodeText:
      'Партнер не найден. Введите код партнера еще раз:',
  },
  finishCredentials: {
    titleText: 'Ваши подчиненные зарегистрированы',
    detailsText:
      'Вашим подчиненным мы создали логины\nи одноразовые пароли для входа. Сохраните их\nи сообщите подчиненным.',
    printActionText: 'Распечатать',
    downloadActionText: 'Открыть PDF с данными подчиненных',
    submitText: 'Завершить регистрацию',
    tableFullNameHeadingText: 'Персона',
    tableLoginHeadingText: 'Логин',
    tablePasswordHeadingText: 'Пароль',
  },
  finishIntermediate: {
    titleText: 'Ваш аккаунт в AGM создан!',
    actionText: 'Далее →',
  },
  finishComplete: {
    savePhoneInstructionText:
      'Это ваш номер телефона. Используйте его для входа в приложение.',
    actionText: 'Далее →',
  },
  finishCompleteFallbackDescriptionText: `Сейчас мы${NON_BREAKING_SPACE}создаем аккаунт персонально${NON_BREAKING_SPACE}для${NON_BREAKING_SPACE}вас.
Это может занять 1-2${NON_BREAKING_SPACE}минуты. Пожалуйста,${NON_BREAKING_SPACE}подождите…`,
  fallback: {
    titleText: 'Упс...',
    descriptionText(mailLink, tgLink) {
      return (
        <TextComponent>
          <ParagraphComponent>
            Извините, создание аккаунта временно недоступно из-за большого
            количества запросов.
          </ParagraphComponent>
          <ParagraphComponent>
            Создайте аккаунт позже или обратитесь в поддержку:{'\n'}email{' '}
            {mailLink}, telegram {tgLink}
          </ParagraphComponent>
        </TextComponent>
      );
    },
    actionText: 'Создать аккаунт',
  },
};
